import { Box } from "grommet";
import React, { CSSProperties } from "react";
import { StyleSheet } from "../../../../../typings/StyleSheet";
import StandardColors from "../../../../../util/StandardColors";

function CustomCard({
  children,
  containerStyle,
  onClick,
  className,
}: {
  children: React.ReactNode;
  containerStyle: CSSProperties;
  onClick?: () => void;
  className?: string;
}) {
  return (
    <Box
      onClick={onClick}
      style={{ ...styles.container, ...containerStyle }}
      elevation="xsmall"
      className={className ?? ""}
    >
      {children}
    </Box>
  );
}

const styles: StyleSheet = {
  container: {
    // display: "flex",
    // flexDirection: "column",
    backgroundColor: StandardColors.white,
    borderRadius: 12,
  },
};

export default CustomCard;
